import { useEffect, useMemo, useCallback } from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import ReactPaginate from 'react-paginate'
import { useMain } from '../../contexts/MainContext'

import api from '../../services/api'

import { Header } from '../../components/Header'
import { ModalAdd } from '../../components/ModalAdd'
import { ModalEdit } from '../../components/ModalEdit'
import { ModalDelete } from '../../components/ModalDelete'
import { Botao } from '../../components/Botao'

import Edit from '../../assets/edit.svg'
import Checked from '../../assets/checked.svg'
import Unchecked from '../../assets/unchecked.svg'
import Trash from '../../assets/trash.svg'

import banner2 from '../../assets/banner2.png'

import { Container, Title, Content, Table } from './styles'

export function CinemaContent() {
 const title = 'Cinema'
 const subtitle = 'Conteúdo da página'

 const fields = useMemo(
  () => [
   {
    id: 'Conteúdo Cinema',
    imagem: String,
    title: String,
    text: String,
    btn_title: String,
    link: String,
    status: Number
   }
  ],
  []
 )

 const {
  contentCinema,
  setContentCinema,
  modalAdd,
  toggleModalAdd,
  modalEdit,
  toggleModalEdit,
  modalDelete,
  toggleModalDelete,
  id,
  setID,
  offset,
  limit,
  handlePageClick
 } = useMain()

 const pageCount = Math.ceil(contentCinema.length / limit)

 const loadContent = useCallback(async () => {
  try {
   const response = await api.get('cinema')

   setContentCinema(response.data)
  } catch (error) {
   console.log('Ocorreu um erro ao buscar o conteúdo ')
  }
 }, [setContentCinema])

 useEffect(() => {
  loadContent()
 }, [loadContent])

 return (
  <>
   <ToastContainer />

   {modalAdd && (
    <ModalAdd
     isClose={toggleModalAdd}
     isLoad={loadContent}
     fields={fields}
     name="cinema"
     title="Conteúdo da página - Cinema"
    />
   )}
   {modalDelete && (
    <ModalDelete
     isClose={toggleModalDelete}
     isLoad={loadContent}
     id={id}
     name="cinema"
     title="Conteúdo da página - Cinema"
    />
   )}
   {modalEdit && (
    <ModalEdit
     isClose={toggleModalEdit}
     isLoad={loadContent}
     id={id}
     name="cinema"
     folder="cinema"
     title="Conteúdo da página - Cinema"
    />
   )}

   <Header title={title} subtitle={subtitle} />
   <Container>
    <Title>Gerenciador de conteúdo</Title>
    {contentCinema.length <= 0 ? (
     <>Nenhum conteúdo cadastrado.</>
    ) : (
     <>
      <Table>
       <thead>
        <tr>
         <th>Exibição</th>
         <th>Imagem</th>
         <th>Title</th>
         <th>Status</th>
         <th colSpan="2"></th>
        </tr>
       </thead>
       <tbody>
        {contentCinema &&
         contentCinema.slice(offset, offset + limit).map(content => (
          <tr key={content.id}>
           <td>{content.id}</td>
           <td>
            <div>
             {content.file ? (
              <img
               src={`${process.env.REACT_APP_IMAGE_URL}/uploads/cinema/${content.file}`}
               alt={content.title}
              />
             ) : (
              ''
             )}
            </div>
           </td>
           <td>{content.title}</td>
           <td>
            {content.status === 1 ? (
             <img src={Checked} alt="Ativo" />
            ) : (
             <img src={Unchecked} alt="Inativo" />
            )}
           </td>
           <td onMouseDown={() => setID(content.id)}>
            <img
             src={Edit}
             alt="Editar"
             title="Editar"
             onClick={toggleModalEdit}
            />
           </td>
           <td onMouseDown={() => setID(content.id)}>
            <img
             src={Trash}
             alt="Deletar"
             title="Deletar"
             onClick={toggleModalDelete}
            />
           </td>
          </tr>
         ))}
       </tbody>
      </Table>

      <ReactPaginate
       previousLabel={'<'}
       nextLabel={'>'}
       pageCount={pageCount}
       onPageChange={handlePageClick}
       containerClassName={'pagination'}
       previousLinkClassName={'pagination__link'}
       nextLinkClassName={'pagination__link'}
       disabledClassName={'pagination__link--disabled'}
       activeClassName={'pagination__link--active'}
      />
     </>
    )}
   </Container>

   <Container>
    <Title>Especificações do banner</Title>
    <Content>
     <div>
      <img src={banner2} alt="Banner foto + texto" />
      <h3>Banner foto + texto</h3>
      <p>Formato: 1106 x 640 pixels</p>
      <p>Tamanho: Máximo 1MB</p>
     </div>
    </Content>
   </Container>

   <Botao isOpen={toggleModalAdd} />
  </>
 )
}
